import { Component, OnInit, OnDestroy } from '@angular/core';
import { EntityDatatableComponent } from '../../../core/components/entity-datatable/entity-datatable.component';
import { LiftParameterSettingsList } from '../../models/lift-parameter-settings-list.model';
import { LiftParameterSettingsService } from '../../services/lift-parameter-settings.service';
import { LiftParameterSettingsCriteria } from '../../models/lift-parameter-settings.criteria';
import { ActivatedRoute, Router } from '@angular/router';
import { LiftModuleService } from '../../services/lift-module.service';
import { EntityListRefresh } from '../../../core/services/entity-list.refresh';
import { ProgressBarService } from '../../../core/services/progress-bar.service';
import { UINotificationService } from '../../../core/services/ui-notification.service';

@Component({
  selector: 'app-lift-parameter-settings',
  templateUrl: './lift-parameter-settings.component.html',
  styleUrls: ['./lift-parameter-settings.component.css']
})
export class LiftParameterSettingsComponent extends EntityDatatableComponent<LiftParameterSettingsList, LiftParameterSettingsCriteria, LiftParameterSettingsService> implements OnInit, OnDestroy {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private parameterService: LiftParameterSettingsService,
    entityListRefresh: EntityListRefresh,
    progressBarService: ProgressBarService,
    private uiNotificationService: UINotificationService
  ) {
    super(
      'lift-parameter-settings',
      new LiftParameterSettingsCriteria(),
      entityListRefresh,
      parameterService,
      progressBarService
    );

    this.sortItems = [
      {
        title: 'Id',
        code: 'id',
        sortOrder: 'asc',
        width: 100,
        disabled: true,
        isEmpty: false,
        class: null
      },
      {
        title: 'Kód',
        code: 'code',
        sortOrder: 'asc',
        width: 156,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'Název',
        code: 'description',
        sortOrder: 'asc',
        width: 300,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'Typ',
        code: 'type',
        sortOrder: 'asc',
        width: 300,
        disabled: false,
        isEmpty: false,
        class: null
      },
      {
        title: 'Akce',
        code: 'action',
        sortOrder: 'asc',
        width: 50,
        disabled: true,
        isEmpty: true,
        class: null
      }
    ];
  } 

  ngOnInit() {
    this.initData(this.route.snapshot.data.parameters);
  }

  ngOnDestroy() {
    this.destroyData();
  }

  createLiftParameter() {
    this.router.navigate([{ outlets: { modal: 'create-lift-parameter-settings' } }]);
  }

  goToDetail(id: number) {
    this.router.navigate([{ outlets: { modal: ['lift-parameter-settings-detail', id] } }]);
  }

  formatType(formatType: number) {
    if (formatType == 1) {
      return 'String';
    }

    if (formatType == 2) {
      return 'Int';
    }

    if (formatType == 3) {
      return 'Enum';
    }

    if (formatType == 4) {
      return 'IO';
    }
  }

}
